import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";

export const fetchAllStaffs = async () => {
    try {
        const response = await fetch(`${baseUrl}/api/staff/getallstaff`, {headers});
        const resData = await response?.json();
       
        return resData;
    } catch (err) {
       
    }
};

export const createStaff = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/staff/create`, {
            method: 'POST',
            body: data,
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};

export const deleteStaff = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/staff/deletestaff/${data}`, {
            method: 'DELETE',
            headers: headers,
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};